module.exports = __webpack_public_path__ + "static/img/contact-qa.caa44ff6.svg";